import { useContext } from "react";
import "./restaurant-loader.styles.scss";
import { LoaderContext } from "../../../contexts/loader.context";
const RestaurantLoader = () => {
  const { loaderClass, setLoaderClass } = useContext(LoaderContext);
  return (
    <div className={loaderClass}>
      <div className="loader"></div>
    </div>
  );
};
export default RestaurantLoader;
